module.exports = __webpack_public_path__ + "img/emailmsg.3b427b5f.png";